import { gatewayInstance } from "../axiosInstance";
import { SERVICE_ENDPOINT } from "../const";

const BASE_PATH = `${SERVICE_ENDPOINT.TRANSPORT}/agreement-template`;

const statusMessageMap = {
  400: "Invalid request. Please check required fields.",
  404: "Agreement template not found.",
  409: "Duplicate agreement code or title.",
  500: "Server error occurred while processing agreement template.",
};

export const getAgreementTemplateErrorMessage = (
  error,
  fallback = "Request failed. Please try again.",
) => {
  const status = error?.response?.status;
  if (!status) {
    return fallback;
  }

  return statusMessageMap[status] || fallback;
};

export const createAgreementTemplate = async (payload) => {
  const response = await gatewayInstance.post(`${BASE_PATH}/create`, payload);
  return response.data;
};

export const updateAgreementTemplate = async (payload) => {
  const response = await gatewayInstance.put(`${BASE_PATH}/update`, payload);
  return response.data;
};

export const getAgreementTemplateList = async () => {
  const response = await gatewayInstance.get(BASE_PATH);
  return response.data || [];
};

export const getAgreementTemplateById = async (agtId) => {
  const response = await gatewayInstance.get(`${BASE_PATH}/${agtId}`);
  return response.data;
};

export const deleteAgreementTemplate = async (agtId) => {
  const response = await gatewayInstance.put(`${BASE_PATH}/delete/${agtId}`);
  return response.data;
};

export const searchAgreementTemplate = async (data) => {
  try {
    const response = await gatewayInstance.post(`${BASE_PATH}/search`, data);
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const renderAgreementTemplate = async (payload) => {
  const response = await gatewayInstance.post(`${BASE_PATH}/render`, payload);
  return response.data;
};

export const downloadAgreementTemplatePdf = async (payload) => {
  const response = await gatewayInstance.post(`${BASE_PATH}/render/pdf`, payload, {
    responseType: "blob",
  });
  return response.data;
};

export const getAllActiveTempPlaceHolders = async () => {
  try {
    const response = await gatewayInstance.get(`${SERVICE_ENDPOINT.TRANSPORT}/template-placeholders/all`);
    return response.data;
  } catch (error) {
    console.error(error);
    return [];
  }
};
